<template>
  <div class="fixed-box">
    <!-- 下载APP -->
    <div class="fixed-btn fixed-btn-dl" v-if="webType==='pc'">
      <a href="/download#dl"
        ><i class="ico"></i><span class="text">下载<br />APP</span></a
      >
    </div>
    <!-- 固定回到顶部 -->
    <div class="fixed-btn fixed-btn-top" id="to-top" v-if="webType==='pc'">
      <a href="#top"
        ><i class="ico"></i><span class="text">返回<br />顶部</span></a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoTop',
  data() {
    return {
      flag: false,
    }
  },
  computed:{
    webType(){
      return this.$store.state.webType
    }
  },
  watch:{
  },
  methods: {
    GoTop() {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll)
        window.scrollTo(0, currentScroll - currentScroll / 10)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.fixed-btn {
  width: 65px;
  height: 65px;
  border-radius: 4px;
  background-color: #1243a3;
  position: fixed;
  right: 0;
  z-index: 999;
  a {
    color: #fff;
    font-size: 16px;
    text-align: center;
    width: 100%;
    height: 65px;
    display: block;
    .text {
      display: none;
      color: #fff;
    }
  }
  .ico {
    width: 100%;
    height: 65px;
    display: block;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 50%;
  }
  &.fixed-btn-dl {
    bottom: 200px;
    .ico {
      background-image: url(//cdncrystal.bluestonehk.com/images/dl@2x.png);
    }
  }
  &.fixed-btn-top {
    bottom: 47px;
    .ico {
      background-image: url(//cdncrystal.bluestonehk.com/images/to_top@2x.png);
    }
  }
  &.fixed-btn {
    &:hover {
      .ico {
        display: none;
      }
      .text {
        padding-top: 12px;
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue